import { render } from "./general_dialysis_setting.vue?vue&type=template&id=8b31c18e&scoped=true"
import script from "./general_dialysis_setting.vue?vue&type=script&lang=js"
export * from "./general_dialysis_setting.vue?vue&type=script&lang=js"

import "./general_dialysis_setting.vue?vue&type=style&index=0&id=8b31c18e&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b31c18e"]])

export default __exports__